module.exports = __webpack_public_path__ + "static/img/slide_5.6d81094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_5.png
// module id = +NVa
// module chunks = 0